import React, { FC } from 'react';
import translate from '@translate';
import { WebhookDeliveryGridMode } from 'skladon-types';
import { ReloadIcon } from 'src/components/SkladonIcon/Icons';
import WebhooksSettingsTopBlock from '../SettingsContainer/WebhooksSettingsTopBlock';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { SxProps, Theme } from '@mui/material/styles';
import { colors, sizes } from 'src/themes/default';

type TopBlockProps = {
    reloadTableData: () => void;
    mode: WebhookDeliveryGridMode;
    onChangeMode: (mode: WebhookDeliveryGridMode) => void;
};

const modeToggleButtonSx: SxProps<Theme> = {
    textTransform: 'none',
    padding: '8px 16px',
    color: colors.text_T2,
    backgroundColor: colors.background_W,
    borderColor: colors.text_T3,
    borderRadius: sizes.radius,
    '&:hover': {
        backgroundColor: colors.background_BQ,
    },
    '&.Mui-selected': {
        zIndex: 1,
        color: colors.primary_O,
        backgroundColor: colors.background_W,
        borderColor: colors.primary_O,
        '&:hover': {
            backgroundColor: colors.background_BQ,
        },
    },
};

const TopBlock: FC<TopBlockProps> = (props) => {
    return (
        <WebhooksSettingsTopBlock
            actions={[
                {
                    node: (
                        <ToggleButtonGroup
                            exclusive
                            value={props.mode}
                            onChange={(_, value) => value && props.onChangeMode(value as WebhookDeliveryGridMode)}
                            size="small"
                            data-testid="webhook-records-mode-toggle"
                        >
                            <ToggleButton value="grouped" sx={modeToggleButtonSx}>
                                {translate('webhookRecords.mode.grouped')}
                            </ToggleButton>
                            <ToggleButton value="attempts" sx={modeToggleButtonSx}>
                                {translate('webhookRecords.mode.attempts')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    ),
                },
                {
                    onClick: props.reloadTableData,
                    icon: <ReloadIcon />,
                    tooltip: translate('webhookRecords.action.synchronizeTable'),
                    variant: 'outlined',
                },
            ]}
        />
    );
};

export default TopBlock;
